module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_her2st.f19dddf6.png";